import { Skeleton, Stack, Typography, useTheme, styled } from '@mui/material';
import {
  JsonView,
  allExpanded,
  darkStyles,
  defaultStyles,
} from 'react-json-view-lite';

import 'react-json-view-lite/dist/index.css';
import QueryResultsFooter from './queryResultsFooter';

interface QueryResultsTreeProps {
  queryId?: string;
  data?: string[][];
  headerColumns?: string[];
  executionTime?: number;
  loading: boolean;
  resultsLink?: string | null;
}

const DBResultsWrapper = styled('div')(function ({ theme }) {
  const isDarkMode = theme.palette.mode === 'dark';
  return {
    display: 'block',
    whiteSpace: 'nowrap',
    height: 'calc(100% - 50px)',
    overflow: 'auto',
    borderRadius: '16px 16px 0 0',
    backgroundColor: isDarkMode ? '#505050' : '#EDEDED',
  };
});

export default function QueryResultsTree(props: QueryResultsTreeProps) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <div
      style={{
        height: '100%',
        backgroundColor: isDarkMode ? '#505050' : '#EDEDED',
        borderRadius: '16px',
      }}
    >
      {!props.loading && props.data && (
        <>
          <DBResultsWrapper>
            <JsonView
              data={(props?.data ?? []).map((record) =>
                Object.fromEntries(
                  props.headerColumns?.map((col, i) => [col, record[i]]) ?? []
                )
              )}
              shouldExpandNode={allExpanded}
              style={isDarkMode ? darkStyles : defaultStyles}
            />
          </DBResultsWrapper>
          <QueryResultsFooter {...props} />
        </>
      )}
      {props.loading && (
        <Stack
          className='h-full text-center'
          justifyContent='center'
          alignItems='center'
        >
          <Typography variant='body2'>
            Please wait while we process your request.
          </Typography>
          <Typography variant='body2'>
            This operation could potentially require a significant amount of
            time.
          </Typography>
          <Skeleton width='200px' className='mt-[16px]' />
        </Stack>
      )}
    </div>
  );
}
